import { render, staticRenderFns } from "./Penetration.vue?vue&type=template&id=126b4572"
import script from "./Penetration.vue?vue&type=script&lang=js"
export * from "./Penetration.vue?vue&type=script&lang=js"
import style0 from "./Penetration.vue?vue&type=style&index=0&id=126b4572&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports